// const baseHttpUrl = 'http://192.168.18.167:81'     //内网-小曹
// const baseHttpUrl = 'http://192.168.18.55:81'     //内网-武京
// const baseHttpUrl = 'http://192.168.18.252:8081'     //服务器
const baseHttpUrl = 'https://server.sanchangsys.com'     //外网

const baseApi = {
  // FILEPATH: 'http://192.168.18.167:8888/file', //内网-小曹
  // FILEPATH: 'http://192.168.18.252:80/file', //服务器
  FILEPATH: 'https://www.sanchangsys.com/file', //外网
  FILEDELETE: baseHttpUrl + '/file/delete',
  DOWNLOADFILE: baseHttpUrl + '/file/files',
  EXPORTEXCEL: baseHttpUrl + '/productData/exportExcel',
  FILE_UPLOAD: baseHttpUrl + '/file/upload',
  IMPORTEXCEL: baseHttpUrl + "/productData/importExcel",
  EXCEL_TEMPLATE: baseHttpUrl + "/productData/excelTemplate",
  SUPPLIEREXCEL: baseHttpUrl + '/supplier/excel',//供应商档案导出
  // 分页接口
  PURCHASE_LIST: baseHttpUrl + "/productData/page",
  SUPPLIERS_LIST: baseHttpUrl + "/supplier/page", //供应商列表
  COSTOMER_LIST: baseHttpUrl + "/customerManagement/page", //客户列表
  BUDGT_LIST: baseHttpUrl + "/budgetItems/page", //预算项目
  REVENUE_COST_BUDGET_LIST: baseHttpUrl + "/revenueCostBudget/paymentBudgeList",  //主要业务收入及成本预算
  PROJECT_LIST: baseHttpUrl + "/projectInformation/page", //项目管理
  FORM_LIST: baseHttpUrl + "/productData/search", //项目管理
  TODO_LIST: baseHttpUrl + "/processExecution/toDoList", //待办
  SESSION_OTHERMEETING_PAGE: baseHttpUrl + "/sessionsOther/page",
  PROJECTPLAN_PAGEPLAN: baseHttpUrl + '/projectPlan/pagePlan',
  PROJECTPLAN_PAGEDAILY: baseHttpUrl + '/projectDaily/pageDaily',
  PRICE_EXPORT: baseHttpUrl + '/productData/exportPriceExcel',
  SESSIONSMAIN_EXCEL_TEMPLATE: baseHttpUrl + '/sessionsMain/excelTemplate', // 导出主要会议模板
  SESSIONSMAIN_EXCEL_EXPORT: baseHttpUrl + '/sessionsMain/exportExcel', //导出主要会议
  SESSIONSMAIN_EXCEL_IMPORT: baseHttpUrl + '/sessionsMain/importExcel', //导入主要会议信息
  SESSIONSOTHER_EXCEL_TEMPLATE: baseHttpUrl + '/sessionsOther/excelTemplate', //导出其他会议模板
  SESSIONSOTHER_EXCEL_EXPORT: baseHttpUrl + '/sessionsOther/exportExcel', //导出其他会议
  SESSIONSOTHER_EXCEL_IMPORT: baseHttpUrl + '/sessionsOther/importExcel', //导入其他会议信息
  PROJECTDAILY_EXCEL_TEMPLATE: baseHttpUrl + '/projectDaily/excelTemplate', //导出项目日报模板
  PROJECTDAILY_EXCEL_EXPORT: baseHttpUrl + '/projectDaily/exportExcel', //导出项目日报
  PROJECTDAILY_EXCEL_IMPORT: baseHttpUrl + '/projectDaily/importExcel', //导入项目日报信息

  //售前项目   
  PRE_SALES_PROJECT_LIST: baseHttpUrl + "/saleProjectInformation/page",
  //项目列表
  EXPORT_PROJECT_LIST: baseHttpUrl + "/projectInformation/exportExcel",//导出项目列表
  //存草稿列表
  FORMTEMPLATE_FORMLIST: baseHttpUrl + "/formTemplate/formList",

  //------------数据导出
  //采购部-列表
  DEPARTMENTTEMPLATE_LISTPURCHASE: baseHttpUrl + "/departmentTemplate/listPurchase",
  //采购部-导出
  DEPARTMENTTEMPLATE_EXPORTEXCELPURCHASE: baseHttpUrl + "/departmentTemplate/exportExcelPurchase",
  //商务部-投标数据列表
  DEPARTMENTTEMPLATE_EXPORTEXCELBIDDINGBUSINESSLIST: baseHttpUrl + "/departmentTemplate/exportExcelBiddingBusinessList",
  //商务部-投标数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELBIDDINGBUSINESS: baseHttpUrl + "/departmentTemplate/exportExcelBiddingBusiness",
  //商务部-合同数据列表
  DEPARTMENTTEMPLATE_LISTCOMERCE: baseHttpUrl + "/departmentTemplate/listComerce",
  //商务部-合同数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELCOMERCE: baseHttpUrl + "/departmentTemplate/exportExcelComerce",
  //活动策划部-合同数据列表
  DEPARTMENTTEMPLATE_LISTEVENTPLANING: baseHttpUrl + "/departmentTemplate/listEventPlaning",
  //活动策划部-合同数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELEVENTPLANING: baseHttpUrl + "/departmentTemplate/exportExcelEventPlaning",
  //设计部-数据列表
  DEPARTMENTTEMPLATE_LISTDESIGNDEPARTMENT: baseHttpUrl + "/departmentTemplate/listDesignDepartment",
  //设计部-数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCEL: baseHttpUrl + "/departmentTemplate/exportExcel",
  //财务部-项目汇总数据列表
  DEPARTMENTTEMPLATE_EXPORTEXCELFINANCECUSTOMERREVENUELIST: baseHttpUrl + "/departmentTemplate/exportExcelFinanceCustomerRevenueList",
  //财务部-项目汇总数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELFINANCECUSTOMERREVENUE: baseHttpUrl + "/departmentTemplate/exportExcelFinanceCustomerRevenue",
  //财务部-项目完工汇总数据列表
  DEPARTMENTTEMPLATE_EXPORTFINANCECOMPLETIONSUMMARYLIST: baseHttpUrl + "/departmentTemplate/exportFinanceCompletionSummaryList",
  //财务部-项目完工汇总数据导出
  DEPARTMENTTEMPLATE_EXPORTFINANCECOMPLETIONSUMMARY: baseHttpUrl + "/departmentTemplate/exportFinanceCompletionSummary",
  //财务部-项目收入、成本分类数据导出
  DEPARTMENTTEMPLATE_EXPORTPROJECTREVENUECOST: baseHttpUrl + "/departmentTemplate/exportProjectRevenueCost",
  //财务部-账龄分析数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELAGINGANALYSIS: baseHttpUrl + "/departmentTemplate/exportExcelAgingAnalysis",
  //财务部-项目收付款数据列表
  DEPARTMENTTEMPLATE_FINANCEPROJECTRECEIPTPAYMENTLIST: baseHttpUrl + "/departmentTemplate/financeProjectReceiptPaymentList",
  //财务部-项目收付款数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELFINANCEPROJECTRECEIPTPAYMENT: baseHttpUrl + "/departmentTemplate/exportExcelFinanceProjectReceiptPayment",
  //财务部-项目收入、成本及利润数据列表
  DEPARTMENTTEMPLATE_PROJECTREVENUECOSTPROFITLIST  : baseHttpUrl + "/departmentTemplate/projectRevenueCostProfitList",
  //财务部-项目收入、成本及利润数据导出
  DEPARTMENTTEMPLATE_EXPORTEXCELREVENUECOSTPROFIT: baseHttpUrl + "/departmentTemplate/exportExcelRevenueCostProfit",
  //财务部-项目汇总表导出
  DEPARTMENTTEMPLATE_EXPORTEXCELPROJECTSUMMARY: baseHttpUrl + "/departmentTemplate/exportExcelProjectSummary",
  //财务部-项目投标保证金汇总表导出
  DEPARTMENTTEMPLATE_EXPORTPROJECTBIDBOND: baseHttpUrl + "/departmentTemplate/exportProjectBidBond",
  //财务部-项目履约保证金、质保金汇总表导出
  DEPARTMENTTEMPLATE_EXPORTPROJECTWARRANTY: baseHttpUrl + "/departmentTemplate/exportProjectWarranty",
  //信息技术部-列表
  DEPARTMENTTEMPLATE_LISTINFORMATIONTECHNOLOGY: baseHttpUrl + "/departmentTemplate/listInformationTechnology",
  //信息技术部-导出
  DEPARTMENTTEMPLATE_INFORMATIONTECHNOLOGYEXPORTEXCEL: baseHttpUrl + "/departmentTemplate/informationTechnologyExportExcel",
  //软件研发部-列表
  DEPARTMENTTEMPLATE_LISTSOFTWARE: baseHttpUrl + "/departmentTemplate/listSoftware",
  //软件研发部-导出
  DEPARTMENTTEMPLATE_LISTSOFTWAREEXCEL: baseHttpUrl + "/departmentTemplate/listSoftwareExcel",

  // 采购产品数据-列表
  CONTRACTPURCHASEPRODUCTS_LIST: baseHttpUrl + "/contractPurchaseProducts/list",
  // 采购产品数据-导出
  CONTRACTPURCHASEPRODUCTS_EXPORT: baseHttpUrl + "/contractPurchaseProducts/export",
}

export default {
  baseApi: baseApi
}